import { render, staticRenderFns } from "./OpinionOtherUserListTab.vue?vue&type=template&id=67c7c4cb&scoped=true&lang=pug"
import script from "./OpinionOtherUserListTab.vue?vue&type=script&lang=ts"
export * from "./OpinionOtherUserListTab.vue?vue&type=script&lang=ts"
import style0 from "./OpinionOtherUserListTab.vue?vue&type=style&index=0&id=67c7c4cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7c4cb",
  null
  
)

export default component.exports